module.exports = __webpack_public_path__ + "img/AMEX_LOCAL.54845247.svg";